import { useQuery } from '@tanstack/react-query';
import { killshotApi } from '../api';

const fetchDataIQZones = async (eventId = '') => {
  const response = await killshotApi.get(`v1/event/${eventId}/data_iq_zones`);
  return response;
};

export const useQueryDataIQZones = eventId => {
  const { data, isFetching, error, status } = useQuery({
    queryKey: ['/event/data_iq_zones', eventId],
    queryFn: () => fetchDataIQZones(eventId),
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 5 * 60 * 1000, // 5 minutes
  });
  return {
    data,
    isFetching,
    status,
    error,
  };
};
